import React, { useRef } from 'react'
import ErrorBoundary from '../../../../components/Common/ErrorBoundary';

const MultipleDetailKPI = ({ handleModalShow, widgetData, widgetConfig , isDarkTheme}) => {
    const { WidgetName = 'MultiKPI', WidgetColor = '#4dd0e1', Entity = '', WidgetID = '', widgetName = '', Datapoints = [] } = widgetConfig || {}
    const { WidgetData = {} } = widgetData || {}
    const ref = useRef(null);


        // Add this before using WidgetData
    const normalizedWidgetData = React.useMemo(() => {
        if (!WidgetData || typeof WidgetData !== "object") return {};
        const result = {};
        Object.entries(WidgetData).forEach(([device, statusObj]) => {
          result[device] = { ...statusObj };

          // Ensure Online/Offline always present together
          // if ("Offline" in statusObj && !("Online" in statusObj)) {
          //     result[device].Online = 0;
          // }
          // if ("Online" in statusObj && !("Offline" in statusObj)) {
          //     result[device].Offline = 0;
          // }

          // // Ensure Normal/Faulty always present together
          // if ("Faulty" in statusObj && !("Normal" in statusObj)) {
          //     result[device].Normal = 0;
          // }
          // if ("Normal" in statusObj && !("Faulty" in statusObj)) {
          //     result[device].Faulty = 0;
          // }

          // // If Zone Alert is present, ensure No Information and Zone Restoral are also present
          // if ("Zone Alert" in statusObj) {
          //     if (!("No Information" in statusObj)) {
          //         result[device]["No Information"] = 0;
          //     }
          //     if (!("Zone Restoral" in statusObj)) {
          //         result[device]["Zone Restoral"] = 0;
          //     }
          // }
          // // If No Information is present, ensure Zone Alert and Zone Restoral are also present
          // if ("No Information" in statusObj) {
          //     if (!("Zone Alert" in statusObj)) {
          //         result[device]["Zone Alert"] = 0;
          //     }
          //     if (!("Zone Restoral" in statusObj)) {
          //         result[device]["Zone Restoral"] = 0;
          //     }
          // }
          // // If Zone Restoral is present, ensure No Information and Zone Alert are also present
          // if ("Zone Restoral" in statusObj) {
          //     if (!("No Information" in statusObj)) {
          //         result[device]["No Information"] = 0;
          //     }
          //     if (!("Zone Alert" in statusObj)) {
          //         result[device]["Zone Alert"] = 0;
          //     }
          // }
      });
        return result;
    }, [WidgetData]);

    const handleClick = (status, device) => {
        if (handleModalShow) {
            // Determine dynamic key names from Datapoints or use defaults
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            //const csvFileName = `${Entity.toLowerCase()}_data_${yyyy}-${mm}-${dd}`;
            const csvFileName = `${device.toLowerCase()}_${status === null? 'all': status.toLowerCase()}_data_${yyyy}-${mm}-${dd}`;
            let Filter = {};
            if(Entity == 'DeviceStatus'){
              Filter = {
                // Define your filter criteria for device status detailed data here
                'InterfaceTypeName': Datapoints['Interfacetypename'][0],
                'DeviceType': null,
                'StatusFor': device,
                'DeviceStatus': status,
                'IntegrationStatus': null
              }
              //WidgetID 11 is CCTV Details
              if(WidgetID === 11){
                    Filter['IntegrationStatus'] = 'Integrated'
                }
            }
            handleModalShow(Filter, Entity, WidgetID, csvFileName, WidgetName, Datapoints);
        }
    };


    return (
  <ErrorBoundary>
    <div ref={ref} className="wip-widget WidgetPadding p-0" key={`widget-${WidgetID}`}>
      <div className="widget-header" style={{ backgroundColor: WidgetColor }}>{WidgetName}</div>
      <div className='widgetHgt'>
        {Object.values(normalizedWidgetData).every(obj => !obj || Object.keys(obj).length === 0) ? (
          <div style={{ color: "#888", fontWeight: 500, textAlign: "center", padding: "2rem", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            No Data Available
          </div>
        ) : (
          Object.entries(normalizedWidgetData).map(([device, statusObj], idx) => (
            <div className={`widget-body${idx > 0 ? ' pt-0' : ''}`} key={device}>
              <div className='StatusWidgetDiv'>
                <div className='pl-3 pr-3 pt-3' style={{ textAlign: "left" }}>
                  <p className='multiWidgetP'>
                    {device} :{" "}
                    <span
                      style={{ cursor: handleModalShow ? 'pointer' : 'default', fontWeight: 600 }}
                      onClick={() => handleClick(null, device)}
                      title="Show all statuses"
                    >{Object.values(statusObj).reduce((a, b) => a + b, 0)}</span>
                  </p>
                  <div className='BorderLine minWidthKPIDiv pb-3'>
                    <div className="kpi-details">
                      {Object.entries(statusObj).map(([status, value], i) => (
                        <div className='KPI_TextWidth' key={status}>
                          <span
                            className='KPITextValue'
                            style={{
                              color:
                                  status === "Online" || status === "Normal" || status === "Zone Restoral" ? "#28a745"
                                : status === "No Information" ? (isDarkTheme ? "#131415" : "#bababa") 
                                : status === "Unavailable" || status === "Unknown" ? (isDarkTheme ? "#131415" : "#bababa") 
                                : status === "Zone Alert"  ? "#ff9800" 
                                : status === "Offline" || status === "Faulty"  ? "#f44336" 
                                :(isDarkTheme ? "#747474" : "#949494"),
                              cursor: handleModalShow ? 'pointer' : 'default'
                            }}
                            onClick={() => handleClick(status, device)}
                          >
                            {value}
                          </span>
                          <span style={{ display: "block" }}>{status}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  </ErrorBoundary>
);
}

export default MultipleDetailKPI